import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["inputValue", "optionHeight"];
import React, { forwardRef } from "react";
import { useI18n } from "../../../i18n/i18n";
import { OptionBase } from "./shared/OptionBase";
export var CreatableOption = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var inputValue = _ref.inputValue,
    optionHeight = _ref.optionHeight,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useI18n = useI18n(),
    i18n = _useI18n.i18n;
  return /*#__PURE__*/React.createElement(OptionBase, _extends({
    height: optionHeight
  }, rest, {
    ref: ref
  }), i18n._( /*i18n*/{
    comment: "When selected, this component will create a new option with the label 'inputValue' and add it to the list of options",
    id: "Add \"{inputValue}\"",
    values: {
      inputValue: inputValue
    }
  }));
});
CreatableOption.displayName = "CreatableOption";
//# sourceMappingURL=CreatableOption.js.map